import React from 'react';
import { withRouter } from 'react-router-dom';

import { makeStyles } from '@material-ui/core/styles';

import Icon from 'components/atoms/Icon';
import InfoTitleArea from 'components/molecules/MbTable/InfoTitleArea';

const useStyles = makeStyles((theme) => ({
  modalHeader: {
    position: 'relative',
    height: 60,
    borderBottom: '1px solid #e5e8eb',
    backgroundColor: theme.palette.primary.main,
  },
  title: {
    margin: 0,
    fontSize: 18,
    color: '#fff',
    textAlign: 'center',
    lineHeight: '60px',
    '& p': {
      marginTop: 0,
      marginBottom: 0,
    },
  },
  closeBtn: {
    position: 'absolute',
    top: 16,
    right: 20,
    cursor: 'pointer',
  },
}));

/**
 *
 */
const ModalBasic = ({
  headerOpen,
  headerTitle,
  closeBtn,
  closeOnClick,
  children,
  toolTip,
}) => {
  const classes = useStyles();
  return (
    <>
      {headerOpen && (
        <div className={classes.modalHeader}>
          <h2 className={classes.title}>
            {typeof toolTip === 'string' ? (
              <InfoTitleArea
                title={headerTitle}
                tooltipTitle={toolTip}
                iconType="fainfoCircle"
                placement="right"
                iconColor="#fff"
              />
            ) : (
              headerTitle
            )}
          </h2>
          {closeBtn && (
            <div className={classes.closeBtn}>
              <Icon
                icon={'faTimes'}
                color="#fff"
                size="2x"
                onClick={closeOnClick}
              />
            </div>
          )}
          {children}
        </div>
      )}
    </>
  );
};

export default withRouter(ModalBasic);
